module.exports = __webpack_public_path__ + "img/286.4589738c.png";